import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/index';
import { TextContainer } from '@Core/TextContainer/TextContainer';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';

export enum ELOCK_AND_ROLL_JP_LEVELS {
    MINI = 1,
    MINOR,
    MAJOR,
    GRAND
}

export class LockAndRollJackpotTexts extends GameComponent {
    public static readonly STATIC_JACKPOT_PLACEHOLDERS: { [K in ELOCK_AND_ROLL_JP_LEVELS]: string } = {
        [ELOCK_AND_ROLL_JP_LEVELS.MINI]: 'mini_odometer_placeholder',
        [ELOCK_AND_ROLL_JP_LEVELS.MINOR]: 'minor_odometer_placeholder',
        [ELOCK_AND_ROLL_JP_LEVELS.MAJOR]: 'major_odometer_placeholder',
        [ELOCK_AND_ROLL_JP_LEVELS.GRAND]: 'grand_odometer_placeholder'
    };

    private readonly textContainers: TextContainer[] = [];

    private readonly jpLevelMultis: number[] = [];

    constructor(readonly scene: GameScene) {
        super(scene);
    }

    public onCreate(): void {
        Object.entries(LockAndRollJackpotTexts.STATIC_JACKPOT_PLACEHOLDERS).forEach(([level, placeholder]) => {
            const typedLevel = +level as ELOCK_AND_ROLL_JP_LEVELS;
            const multi = this.scene.game.gameStore.get(EGameStoreKeys.LockAndRoll).staticJackpots[typedLevel];
            const spine = this.scene.gameBackground.getBackgroundSpine();
            this.jpLevelMultis.push(multi);
            this.textContainers.push(TextContainer.fromSlot(placeholder, this.scene, this.getText(this.getCurrentBet(), multi)));
            spine.slotManager.assignObjectToSlot(placeholder, this.textContainers.at(-1)!);
        });

        this.scene.game.gameStore.on(EGameStoreKeys.BetState, this.updateText, this);
    }

    private updateText() {
        this.jpLevelMultis.forEach((multi, index) => {
            this.textContainers[index].setText(this.getText(this.getCurrentBet(), multi));
        });
    }

    private getText(bet: number, betMultiplier: number): string {
        const value = bet * betMultiplier;
        return CurrencyUtils.formatRawCurrencyValue(value, {
            hideDecimals: true
        });
    }

    private getCurrentBet() {
        return this.scene.game.gameStore.get(EGameStoreKeys.BetState).value.raw;
    }
}
